import React, { ForwardedRef, forwardRef, memo, PropsWithChildren, ReactElement, Ref } from 'react';
import { DataTable as DataTableNew } from './DataTable';
import { convertOldDataTableProps, OldDataTableProps } from './converter.old';
import type { DataTableInternalProps } from './types';
export type DataTableProps<DataType> = OldDataTableProps<DataType>;

const DataTableInternal = DataTableNew as <DataType extends object>(
  props: PropsWithChildren<DataTableInternalProps<DataType>> & { ref?: Ref<HTMLTableElement> },
) => ReactElement;

export const DataTable = memo(
  forwardRef(<DataType extends object>(props: DataTableProps<DataType>, ref: ForwardedRef<HTMLTableElement>) => (
    <DataTableInternal {...convertOldDataTableProps(props)} ref={ref} />
  )),
) as <DataType extends object>(
  props: PropsWithChildren<DataTableProps<DataType>> & { ref?: Ref<HTMLTableElement> },
) => ReactElement;

(DataTable as typeof DataTable & { displayName?: string }).displayName = 'DataTable';
